import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import OrganizationTable from "./OrganizationsTable";
import OrganizationsHeader from "./OrganizationsHeader";
import OrganizationDrawer from "./OrganizationDrawer";
import OrganizationsDrawerHolidays from "./OrganizationsDrawerHolidays";
// AUTHORIZATION
import { useScreenPermission } from "../../../customHooks/useScopedPermission";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const OrganizationPage = () => {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const { theme } = useSelector((state: RootState) => state.home);
  // Reads SCREEN_PERMISSION["organizations"] -- the same declaration
  // Layout.tsx's sidebar link reads.
  const allowed = useScreenPermission("organizations");

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {allowed ? (
        <div className={`layout__contentPage__${theme}`}>
          <OrganizationsHeader />
          <OrganizationTable />
          <OrganizationDrawer />
          <OrganizationsDrawerHolidays />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default OrganizationPage;
